import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["threadId"];
import { createAsyncThunk } from '@reduxjs/toolkit';
import Raven from 'raven-js';
import { deleteCopilotThreadIdFromSuperstore } from '../../superstore/utils/copilotThreadId';
import { getLatestOrCreateThread } from '../api/threadsApi';
import { convertCopilotV2ThreadToCopilotV1ThreadForRedux } from '../slices/copilotV2ResponseConversions';
export const copilotV2GetLatestOrCreateThread = createAsyncThunk('threads/copilotV2GetLatestOrCreateThread', async (args, {
  rejectWithValue
}) => {
  try {
    let response = await getLatestOrCreateThread(args);

    // If the thread is not found, delete the threadId from superstore and try again.
    if (response.type === 'rpcError' && response.rpcError.type === 'THREAD_NOT_FOUND') {
      await deleteCopilotThreadIdFromSuperstore();
      const argsWithoutThreadId = _objectWithoutPropertiesLoose(args, _excluded);
      response = await getLatestOrCreateThread(argsWithoutThreadId);
    }
    if (response.type === 'rpcError') {
      return rejectWithValue(response.rpcError);
    }
    const {
      messages,
      thread,
      hasMore,
      messageOffset
    } = response.data;

    // This is still getting converted because we are updating the threads redux state

    // Convert response to ThreadMetadata format
    const convertedThread = convertCopilotV2ThreadToCopilotV1ThreadForRedux(thread);

    // NOTE: Don't convert messages to V1 here, implement it in the calling function.
    // We need the raw v2 messages for chatv2 redux state.

    return {
      thread: convertedThread,
      messages,
      hasMore,
      messageOffset
    };
  } catch (error) {
    Raven.captureException(error instanceof Error ? error : new Error(String(error)), {
      extra: {
        component: 'copilotV2GetLatestOrCreateThread',
        action: 'copilotV2GetLatestOrCreateThread',
        copilotVersion: '2'
      }
    });
    return rejectWithValue(error instanceof Error ? error.message : 'Failed to get latest or create thread');
  }
});